// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_BhucC","bonus-item":"bonus-item_z2n8U","m":"m_9KgYL","disable-mask":"disable-mask_vm5ka","text":"text_6jSd4"};